var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draggable-box",style:(_vm.boxStyle),on:{"touchstart":_vm.handleTouchStart,"touchmove":_vm.handleTouchMove,"touchend":_vm.handleTouchEnd,"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }